import DisabledImage from "../assets/img/disabled.png";
import { useTranslation } from "react-i18next";
import { useAuth } from "../hooks/useAuth";
import toast from 'react-hot-toast';

export const DisabledComponent = () => {
    const { t } = useTranslation();
    const { signOut } = useAuth();

    const handleSignOut = async () => {
        const loadingToast = toast.loading("Cerrando sesión...");
        try {
            await signOut();
            toast.dismiss(loadingToast);
        } catch (error) {
            toast.dismiss(loadingToast);
            toast.error(t("Ha ocurrido un error inesperado"));
        }
    };

    return (
        <div className="flex flex-col justify-center items-center px-6 mx-auto h-screen xl:px-0 dark:bg-gray-900">
            <div className="block mb-5 md:max-w-md">
                <img src={DisabledImage} alt="Disabled" />
            </div>
            <div className="text-center xl:max-w-4xl">
                <h1 className="mb-3 text-2xl font-bold leading-tight text-gray-900 sm:text-4xl lg:text-5xl dark:text-white">{t('Cuenta deshabilitada')}</h1>
                <p className="mb-5 text-base font-normal text-gray-500 md:text-lg dark:text-gray-400">
                    {t('Tu cuenta ha sido deshabilitada. Si crees que esto es un error, por favor')} <a href="mailto:golcina@coventia.es" className="text-primary-700 hover:underline dark:text-primary-500">{t('ponte en contacto con nosotros')}</a>.
                </p>
                <button
                    onClick={handleSignOut}
                    className="mt-4 px-6 py-3 text-base font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 focus:outline-none focus:ring-4 focus:ring-primary-300 dark:bg-primary-500 dark:hover:bg-primary-600 dark:focus:ring-primary-800"
                >
                    {t('Cerrar sesión')}
                </button>
            </div>
        </div>
    )
}

